import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

export const VenueQuerySchema = PaginationRequestSchema.extend({
  name: z.string().optional(),
  city: z.string().optional(),
  countryId: z.string().optional(),
});
export type VenueQueryDTO = z.infer<typeof VenueQuerySchema>;

export const VenueResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  countryId: z.string().nullable(),
  capacity: z.number().nullable(),
  surface: z.string().nullable(),
  image: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type VenueResponseDTO = z.infer<typeof VenueResponseSchema>;

export const VenueWithoutTimestampsSchema = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string().nullable(),
  city: z.string().nullable(),
  countryId: z.string().nullable(),
  capacity: z.number().nullable(),
  surface: z.string().nullable(),
  image: z.string().nullable(),
});
export type VenueWithoutTimestampsDTO = z.infer<typeof VenueWithoutTimestampsSchema>;

export const VenuesPaginatedResponseSchema = PaginationResponseSchema(
  VenueResponseSchema
);
export type VenuesPaginatedResponseDTO = z.infer<
  typeof VenuesPaginatedResponseSchema
>;

export const CreateVenueRequestSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  address: z.string().optional(),
  city: z.string().optional(),
  countryId: z.string().optional(),
  capacity: z.number().optional(),
  surface: z.string().optional(),
  image: z.string().optional(),
});

export const UpdateVenueRequestSchema = CreateVenueRequestSchema.partial();

export type CreateVenueRequestDTO = z.infer<typeof CreateVenueRequestSchema>;
export type UpdateVenueRequestDTO = z.infer<typeof UpdateVenueRequestSchema>;
